module.exports = __webpack_public_path__ + "384f1215e2add588afbcb22fb667ba19.png";